import React, { useState } from "react";
import { Box, Avatar, Stack, IconButton, Typography } from "@mui/joy";
import { DeleteOutline } from "@mui/icons-material";
import { formatDistanceToNow } from "date-fns";
import { Comment } from "../../store/commentStore";

interface CommentItemProps {
  comment: Comment;
  isOwn: boolean;
  onDelete: (commentId: string) => void;
}

export const CommentItem: React.FC<CommentItemProps> = ({
  comment,
  isOwn,
  onDelete,
}) => {
  const [confirmDelete, setConfirmDelete] = useState(false);

  const username =
    comment.profile?.username || comment.profile?.full_name || "User";
  const avatarUrl = comment.profile?.avatar_url;
  const timeAgo = formatDistanceToNow(new Date(comment.created_at), {
    addSuffix: true,
  });

  const handleDelete = () => {
    if (confirmDelete) {
      onDelete(comment.id);
      setConfirmDelete(false);
    } else {
      setConfirmDelete(true);
    }
  };

  return (
    <Stack
      data-testid={`comment-item-${comment.id}`}
      direction="row"
      spacing={1}
      sx={{ alignItems: "flex-start", py: 0.5 }}
    >
      <Avatar
        src={avatarUrl || undefined}
        alt={username}
        sx={{ width: 20, height: 20, fontSize: "10px", mt: "2px" }}
      >
        {!avatarUrl && username.charAt(0).toUpperCase()}
      </Avatar>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography
          level="body-xs"
          sx={{ display: "inline", fontWeight: 600, color: "#444" }}
        >
          {username}
        </Typography>{" "}
        <Typography
          level="body-xs"
          sx={{ display: "inline", color: "#555" }}
        >
          {comment.content}
        </Typography>
        <Typography
          level="body-xs"
          sx={{ color: "#aaa", mt: 0.25, fontSize: "11px" }}
        >
          {timeAgo}
        </Typography>
      </Box>
      {isOwn && (
        <IconButton
          data-testid={`comment-delete-${comment.id}`}
          size="sm"
          variant="plain"
          color={confirmDelete ? "danger" : "neutral"}
          onClick={handleDelete}
          onBlur={() => setConfirmDelete(false)}
          sx={{
            minWidth: 24,
            minHeight: 24,
            p: 0,
            "--IconButton-size": "24px",
          }}
        >
          <DeleteOutline sx={{ fontSize: 14 }} />
        </IconButton>
      )}
    </Stack>
  );
};
